import { useEffect, useState } from 'react';
import { AppState } from 'react-native';

/** Keep expiration reactive without reading the clock during render. */
export function useHasExpired(expiresAt: string | null | undefined, fallback: boolean) {
  const [now, setNow] = useState(() => Date.now());
  const expiresAtTime = expiresAt ? new Date(expiresAt).getTime() : undefined;

  useEffect(() => {
    if (expiresAtTime === undefined || !Number.isFinite(expiresAtTime)) return;
    const refresh = () => setNow(Date.now());
    const timeout =
      expiresAtTime >= now
        ? setTimeout(refresh, Math.min(Math.max(expiresAtTime - Date.now() + 1, 0), 2_147_483_647))
        : undefined;
    const subscription = AppState.addEventListener('change', (state) => {
      if (state === 'active') refresh();
    });
    return () => {
      clearTimeout(timeout);
      subscription.remove();
    };
  }, [expiresAtTime, now]);

  return expiresAtTime === undefined ? fallback : expiresAtTime < now;
}
